import SiteDetail from './SiteDetail.vue'

export default SiteDetail
